module.exports = __webpack_public_path__ + "img/drt8.fa0c4227.png";